<script setup>
defineOptions({
  name: 'HomepageSidebarSegmentTitle'
})
</script>

<template>
  <div class="hsst-Title">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.hsst-Title {
  margin-bottom: var(--ob-hpgf-item-gap);
  margin-top: 14px;
  color: var(--gray-300);
  font-weight: fw('semi-bold');
  font-size: $fs-12;
  line-height: 18px;
  text-transform: uppercase;
  padding-inline: var(--ob-hps-mx);
  min-height: 0;
}
</style>
